/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/date_parse.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns a date by parsing the second argument using the format specified in the first argument.
 *
 * @example
 * ROW date_string = "2022-05-06"
 * | EVAL date = DATE_PARSE("yyyy-MM-dd", date_string)
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'date_parse',
  signatures: [
    {
      params: [
        {
          name: 'dateString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'keyword',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'keyword',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'time_zone\', values=[standard], description=\'Coordinated Universal Time (UTC) offset or IANA time zone used to convert date values in the query string to UTC.\', type=[keyword]}, {name=\'locale\', values=[standard], description=\'The locale to use when parsing the date, relevant when parsing month names or week days.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'dateString',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'time_zone\', values=[standard], description=\'Coordinated Universal Time (UTC) offset or IANA time zone used to convert date values in the query string to UTC.\', type=[keyword]}, {name=\'locale\', values=[standard], description=\'The locale to use when parsing the date, relevant when parsing month names or week days.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'keyword',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'keyword',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'text',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'time_zone\', values=[standard], description=\'Coordinated Universal Time (UTC) offset or IANA time zone used to convert date values in the query string to UTC.\', type=[keyword]}, {name=\'locale\', values=[standard], description=\'The locale to use when parsing the date, relevant when parsing month names or week days.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'dateString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'text',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'text',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'keyword',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'time_zone\', values=[standard], description=\'Coordinated Universal Time (UTC) offset or IANA time zone used to convert date values in the query string to UTC.\', type=[keyword]}, {name=\'locale\', values=[standard], description=\'The locale to use when parsing the date, relevant when parsing month names or week days.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'dateString',
          type: 'text',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'time_zone\', values=[standard], description=\'Coordinated Universal Time (UTC) offset or IANA time zone used to convert date values in the query string to UTC.\', type=[keyword]}, {name=\'locale\', values=[standard], description=\'The locale to use when parsing the date, relevant when parsing month names or week days.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'text',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'date',
    },
    {
      params: [
        {
          name: 'datePattern',
          type: 'text',
          optional: true,
        },
        {
          name: 'dateString',
          type: 'text',
          optional: false,
        },
        {
          name: 'options',
          type: 'function_named_parameters',
          optional: true,
          mapParams: '{name=\'time_zone\', values=[standard], description=\'Coordinated Universal Time (UTC) offset or IANA time zone used to convert date values in the query string to UTC.\', type=[keyword]}, {name=\'locale\', values=[standard], description=\'The locale to use when parsing the date, relevant when parsing month names or week days.\', type=[keyword]}',
        },
      ],
      variadic: false,
      returnType: 'date',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
